import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterModule } from "@angular/router";
import { HeaderComponent } from "./components/header/header.component";
import { FooterComponent } from "./components/footer/footer.component";
import { PickupRequestFormComponent } from "./components/pickup-request-form/pickup-request-form.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxSmartModalModule } from "ngx-smart-modal";
import { SignUpEndconsumerComponent } from "./components/sign-up-endconsumer/sign-up-endconsumer.component";
import { LoginEndconsumerComponent } from "./components/login-endconsumer/login-endconsumer.component";
import { ChangePasswordComponent } from "./components/change-password/change-password.component";
import { ForgotPasswordComponent } from "./components/forgot-password/forgot-password.component";
import { TouchHoverDirective } from "./directives/touch-hover.directive";
import { TranslatePipe } from "@ngx-translate/core";
import { SignUpTeamComponent } from "./components/sign-up-team/sign-up-team.component";
import { LoginTeamComponent } from "./components/login-team/login-team.component";
import { BecomeMemberComponent } from "./components/become-member/become-member.component";
import { NgxMaskDirective } from "ngx-mask";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TeamProfileComponent } from "./components/team-profile/team-profile.component";
import { TeamSubscriptionComponent } from "./components/team-subscription/team-subscription.component";
import { OtpComponent } from "./components/otp/otp.component";
import { HowWorksComponent } from "./components/how-works/how-works.component";
import { FeaturesComponent } from "./components/features/features.component";
import { CallToActionComponent } from "./components/call-to-action/call-to-action.component";
import { ReviewsComponent } from "./components/reviews/reviews.component";
import { DownloadComponent } from "./components/download/download.component";
import { ContactFormComponent } from "./components/contact-form/contact-form.component";
import { SportTypePipe } from "./pipes/sport-type.pipe";
import { CookieConsentComponent } from "./components/cookie-consent/cookie-consent.component";
import { NoTeamsInfoComponent } from "./components/no-teams-info/no-teams-info.component";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";

const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  PickupRequestFormComponent,
  SignUpEndconsumerComponent,
  SignUpTeamComponent,
  LoginEndconsumerComponent,
  LoginTeamComponent,
  ChangePasswordComponent,
  ForgotPasswordComponent,
  TouchHoverDirective,
  BecomeMemberComponent,
  TeamProfileComponent,
  TeamSubscriptionComponent,
  OtpComponent,
  HowWorksComponent,
  FeaturesComponent,
  CallToActionComponent,
  ReviewsComponent,
  DownloadComponent,
  ContactFormComponent,
  SportTypePipe,
  CookieConsentComponent,
  NoTeamsInfoComponent
];

const MODULES = [
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  NgxSmartModalModule,
  TranslatePipe,
  NgxMaskDirective,
  NgOptimizedImage,
  NgxIntlTelInputModule,
  BsDropdownModule,
  BsDatepickerModule,
  TimepickerModule,
  PopoverModule
];

@NgModule({
  declarations: [
    ...COMPONENTS
  ],
  imports: [
    ...MODULES
  ],
  exports: [
    ...COMPONENTS,
    ...MODULES
  ]
})
export class SharedModule { }
